
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
const FeatureItem = ({ item, icons }) => {
    return <li className={'benefits_item'}>
        <div className="benefits_item_wrapper">
            {icons[item.icon]}
            <h3 className={'benefits_item_title'}>{item.title}</h3>
            <p className={'benefits_item_text'}>{item.text}</p>
        </div>
    </li>;
};
const Benefits = ({ t }) => {
    const benefits = t('our_vision:benefits', {}, { returnObjects: true });
    const icons = {
        "decentralized": <svg className={'stroke'} xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
            <path d="M37.562 26.0584L39.7988 34.4062" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M10.525 16.2225L18.223 20.6669" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M29.7692 27.3333L37.4671 31.7777" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M40.9111 32.4819L32.5633 34.7187" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M15.4316 13.2812L7.08379 15.518" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M10.4321 21.9409L8.19533 13.5931" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M19.0013 11.2224L25.1123 5.11133" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M23.9986 39.5557L23.9986 30.6669" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M23.9986 17.3336L23.9986 8.44476" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M22.8877 5.11133L28.9987 11.2224" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M19 36.7778L25.111 42.8889" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M29 36.7778L22.889 42.8889" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M10.438 26.0584L8.20117 34.4062" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M37.475 16.2225L29.777 20.6669" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M18.2308 27.3333L10.5329 31.7777" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M7.08887 32.4819L15.4367 34.7187" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M32.5684 13.2812L40.9162 15.518" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M37.5679 21.9409L39.8047 13.5931" stroke="#000034" strokeWidth="4" strokeLinejoin="round"/>
            <circle cx="24" cy="24" r="4" fill="#000034"/>
        </svg>,
        "secure": <svg className={'stroke'} width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 38.5C21 38.5 35 31.5 35 21V8.75L21 3.5L7 8.75V21C7 31.5 21 38.5 21 38.5Z" stroke="#000034" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16.5 20.5L20 24L28 16" stroke="#000034" strokeWidth="4"/>
        </svg>,
        "hardware": <svg className={'fill'} xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
            <path d="M21.1704 26.4337L41.7179 5.88623V21.4525L21.1704 42V26.4337Z" fill="#000034"/>
            <path d="M9.96289 20.3576L26.7745 3.70703V16.3211L9.96289 32.9717V20.3576Z" fill="#000034"/>
            <path d="M0 14.7646L12.7644 1.99997V12.7353L0 25.4999V14.7646Z" fill="#000034"/>
        </svg>,
        "interoperability": <svg className={'fill'} xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M29.75 5.25L38.5 12.25L29.75 19.25V14H22.0294V10.5H29.75V5.25ZM14.8493 10.5H3.5V14H13.6757L20.4104 30.4143L20.8558 31.5H29.75V36.75L38.5 29.75L29.75 22.75V28H23.2029L16.4683 11.5857L16.0228 10.5H14.8493ZM14.8493 31.5H3.5V28H14.8493V31.5Z" fill="#000034"/>
        </svg>,
        "fast": <svg className={'fill'} xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
            <path d="M28.125 33C25.2355 33 22.6823 32.07 20.4656 30.21C18.2489 28.35 16.8833 25.88 16.3688 22.8H2V19.2H16.3711C16.5674 17.92 16.9625 16.69 17.5563 15.51C18.15 14.33 18.8823 13.36 19.7531 12.6H6.75V9H28.125C31.4105 9 34.2109 10.17 36.5266 12.51C38.8422 14.85 40 17.68 40 21C40 24.32 38.8422 27.15 36.5266 29.49C34.2109 31.83 31.4105 33 28.125 33ZM28.1108 29.4C30.416 29.4 32.3802 28.5848 34.0031 26.9544C35.6261 25.3236 36.4375 23.3436 36.4375 21.0144C36.4375 18.6848 35.6308 16.7 34.0174 15.06C32.4036 13.42 30.4442 12.6 28.1393 12.6C25.834 12.6 23.8698 13.4152 22.2469 15.0456C20.6239 16.6764 19.8125 18.6564 19.8125 20.9856C19.8125 23.3152 20.6192 25.3 22.2326 26.94C23.8464 28.58 25.8058 29.4 28.1108 29.4ZM9.125 33V29.4H16.25V33H9.125Z" fill="#000034"/>
        </svg>,
        "use": <svg className={'fill'} xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M20.9985 2.00049L27.2698 14.7296L39.998 21.0011L27.2698 27.2714L20.9985 40.0005L14.7262 27.2716L1.99805 21.0011L14.7262 14.7296L20.9985 2.00049ZM20.9982 11.0194L17.703 17.7066L11.0174 21.0008L17.703 24.2944L20.9982 30.9816L24.2928 24.2944L30.9786 21.0008L24.2928 17.7065L20.9982 11.0194Z" fill="#000034"/>
        </svg>
    };
    return (<section className={'benefits'}>
            <div className="container">
                <h2 className={'benefits_title'}>
                    <span className={''}>{benefits.title}</span>
                </h2>
                <ul className={'benefits_items'}>
                    {benefits.items.map(item => {
            return <FeatureItem key={item.key} item={item} icons={icons}/>;
        })}
                </ul>
            </div>
        </section>);
};
export default Benefits;

    async function __Next_Translate__getStaticProps__196111dc749__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//about/vision/Benefits/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196111dc749__ as getStaticProps }
  